import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ArrowLeft } from "lucide-react";
import { logoutProcessor } from "../helpers/logoutProcessor";
import { useTranslation } from "../../i18n";
import { apiFetch } from "../../api/apiFetch";

type laneInfo = {
    Warehouse: String,
    Batch: number,
    Date: string,
    Lane: string,
    AdditionalLanes?: string[]
}

const ZoneStorageSorter2SelectLane = ({ warehouse, bay, set_Lane, set_additionalLanes, set_Batch, set_Date, goBack }: { warehouse: string; bay: string; set_Lane: React.Dispatch<React.SetStateAction<string>>; set_additionalLanes: React.Dispatch<React.SetStateAction<string[]>>; set_Batch: React.Dispatch<React.SetStateAction<number>>; set_Date: React.Dispatch<React.SetStateAction<string>>; goBack: () => void }) => {
    const navigator = useNavigate();
    const { t } = useTranslation();
    const [availableLanes, set_availableLanes] = useState<laneInfo[]>([]);

    const bayToTypeConversion: { [key: string]: { [key: string]: string } } = {
        "Newport": { "99": "Mega", "01": "Large", "02": "Large", "03": "Medium", "04": "Medium", "05": "Medium", "06": "Small", "07": "PutWall", "08": "PutWall" },
        "Poland": { "99": "Mega", "01": "Large", "02": "Large", "03": "Large", "04": "Large", "05": "Large", "06": "Medium", "07": "Small", "08": "PutWall", "09": "PutWall" },
        "Test": { "99": "Mega", "01": "Large", "02": "Medium", "03": "Small", "04": "PutWall" }
    };

    // Request Lanes
    const init = async () => {
        await apiFetch(`/zonestorage/lanes/get-ready-lanes-by-type`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ warehouse: warehouse, bay: bay, type: bayToTypeConversion[warehouse][bay] })
        }).then(async (res): Promise<any> => {
            let response = await res.json();

            if (res.ok) {
                console.log("Lanes Received:", response);
                set_availableLanes(response.sort((a: laneInfo, b: laneInfo) => a.Lane.padStart(2, '0').localeCompare(b.Lane.padStart(2, '0'))));
            } else if (res.status === 401) {
                console.log("INVALID PERMISSIONS");
                logoutProcessor();
                navigator("/login");
            } else {
                console.log(response.error);
                toast.error(response.message);
            }
        });
    };

    // Get Available Lanes
    useEffect(() => {
        init();
        console.log("Getting Lanes");
    }, []);

    // Handle Lane selection
    const handle_lane_selection = async (lane: laneInfo) => {
        // Get API to mark lane as in use
        await apiFetch(`/zonestorage/lanes/change-in-use-status`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ warehouse: warehouse, date: lane.Date, batch: lane.Batch, lane: lane.Lane, bay: bay, inUse: true, user: "" })
        }).then(async (res): Promise<any> => {
            const response = await res.json();
            if (res.ok) {
                console.log("Complete");

                // Locally mark which lane the user is using
                set_Batch(lane.Batch);
                set_Date(lane.Date);
                set_Lane(lane.Lane);
                set_additionalLanes(lane.AdditionalLanes ?? []);
            } else if (res.status === 401) {
                console.log("INVALID PERMISSIONS");
                logoutProcessor();
                navigator("/login");
            } else if (res.status === 400) {
                toast.error(t("lane_in_use"));
                init();
            } else {
                console.log(response.message);
                toast.error(response.message);
                return;
            }
        });

        return;
    };


    return (
        <div className="page-data">
            <div className="page-title-bar">
                <h1 className="page-title">{t("select_lane")}</h1>
                <button className="page-back-btn" onClick={goBack}><ArrowLeft size={20} /></button>
            </div>

            <div className="zone-select-container">
                {availableLanes.length === 0 && <div>{t("no_lanes")}</div>}
                {availableLanes.length > 0 && availableLanes.map((lane) => {
                    const hasAdditional = (lane.AdditionalLanes?.length ?? 0) > 0;
                    const allLanes = [lane.Lane, ...(lane.AdditionalLanes ?? [])];
                    return (
                        <div key={lane.Lane} className={`zone-select-lane${hasAdditional ? " zone-select-lane-wide" : ""}`}>
                            <button onClick={() => handle_lane_selection(lane)}>
                                {allLanes.map((n, i) => (
                                    <span key={i}>
                                        {i > 0 && <span className="zone-select-lane-sep">&nbsp;&amp;&nbsp;</span>}
                                        {n}
                                    </span>
                                ))}
                            </button>
                        </div>
                    );
                })}
            </div>

        </div>
    )

};

export default ZoneStorageSorter2SelectLane;
